/* istanbul ignore file */
import api from './api';

export default {
    api,
};